module.exports = {
  menu: {
    home: '홈',
    game: '게임',
    connect_login: '지갑 연결/로그인',
    new_game: '게임 입장',
    invite_friends: '친구 초대',
    cms_login: 'CMS 로그인',
    register: '회원가입',
    login: '로그인',
    logout: '로그아웃',
    login_to_play_game: '게임을 즐기려면 로그인하세요',
    select_login_method: '로그인 방법을 선택하세요',
    select_register_method: '회원가입 방법을 선택하세요',
    email: '이메일',
    meta_mask: 'MetaMask',
    player_login: '플레이어 로그인',
    history: '전적',
    transaction_history: '거래 내역',
    ranking: '랭킹',
    purchase: '충전',
    search_game_placeholder: '게임 검색...',
    new_games: '신규 게임',
    frequent: '자주 플레이하는 게임',
    faq: '자주 묻는 질문',
    terms_and_conditions: 'Win4Poker 약관 및 조건',
    tnc: '약관',
    about_us: '회사 소개',
    contact_us: '문의하기',
    settings: '설정',
    lucky_draw: '행운 추첨',
    tournament: '토너먼트',
    announcement: '공지사항',
    no_news: '새 소식이 없습니다',
    online: '온라인',
    deposit: '입금',
    terms_1_title: '참가 자격',
    terms_1_content:
      '모든 플레이어는 만 18세 이상이어야 하며, 법적으로 허용된 지역에서 등록 및 게임을 진행해야 합니다.',
    terms_2_title: '계정 등록',
    terms_2_content: '플레이어는 공식 웹사이트를 통해 계정을 등록해야 합니다.',
    terms_3_title: '게임 규칙',
    terms_3_content:
      '모든 게임은 표준 포커 규칙을 따라야 하며, 부정 행위는 계정 일시 정지 또는 종료로 이어질 수 있습니다.',
    terms_4_title: '입금 및 출금',
    terms_4_content:
      '플레이어는 본 플랫폼의 결제 수단을 사용하여 입금해야 하며, 출금은 플랫폼의 처리 시간에 따라 이루어집니다.',
    terms_5_title: '보너스 분배',
    terms_5_content:
      '보너스는 게임 결과에 따라 분배되며, 구체적인 규칙은 게임 시작 전에 설명됩니다.',
    terms_6_title: '책임 제한',
    terms_6_content:
      '플랫폼은 서비스나 제품 사용 중 발생하는 손실이나 손해에 대해 책임지지 않습니다.',
    terms_7_title: '개인 정보 보호',
    terms_7_content:
      '플레이어의 개인 정보는 기밀로 유지되며, 계정 관리 및 게임 목적으로만 사용됩니다.',
    terms_8_title: '약관 수정',
    terms_8_content:
      '플랫폼은 언제든지 약관을 수정할 권리를 보유하며, 수정 사항은 이메일 또는 웹사이트 공지를 통해 플레이어에게 통지됩니다.',
  },
  common: {
    theme: '기본 프로젝트 백엔드',
    delete_record_confirm_msg: '삭제를 확인하시겠습니까?',
    yes: '예',
    no: '아니오',
    true: '참',
    false: '거짓',
    success: '성공',
    loading: '로드 중',
    or: '또는',
    delete: '삭제',
    login: '로그인',
    submit: '제출',
    apply: '적용',
    cancel: '취소',
    confirm: '확인',
    back_to_lobby: '로비로 돌아가기',
    email: '이메일',
    id_document: '신분증명서',
    all_in_game: '올인 폴드 텍사스 포커',
    all_in_game_omaha: '올인 폴드 오마하',
    regular: '텍사스 포커',
    regular_description: '텍사스 포커는 무제한 베팅으로 진행됩니다',
    short: '쇼트 덱',
    short_description: '쇼트 덱 텍사스 포커는 36장의 카드로 진행됩니다',
    omaha: '오마하',
    omaha_description: '플레이어는 두 장의 홀 카드를 사용하여 핸드를 구성해야 합니다',
    regular_allin: '올인 폴드 텍사스 포커',
    omaha_allin: '올인 폴드 오마하',
    tournament: '토너먼트',
    start: '시작',
    game_demo_area: '게임 체험 구역',
    total_win_prize: '총 상금',
    waiting_list_order: '대기 목록 순서',
    join_more_than_4_room_error: '4개 이상의 방에 참여할 수 없습니다',
    system_message: '시스템 메시지',
    error: '오류',
    register: '회원가입',
    meta_mask: 'MetaMask',
    wallet_connect: 'Wallet Connect',
    password: '비밀번호',
    next_step: '다음 단계',
    next: '다음',
    verify: '검증',
    copy_success: '복사 성공',
    enabled: '활성화됨',
    enable: '활성화',
    disable: '비활성화',
    done: '완료',
    feature_in_progress: '추천 기능이 개발 중입니다. 나중에 다시 확인해주세요.',
    no_data: '데이터 없음',
    date: '날짜',
    retry: '재시도',
    location_restricted_title: '지역 제한',
    location_restricted_content:
      '현재 계신 지역은 제한되어 있습니다. 일부 기능이나 서비스가 제공되지 않을 수 있습니다. 이해해 주셔서 감사합니다.',
    dont_show_again: '다시 표시하지 않기',
    edit: '편집',
    i_am_not_located_in_the_restricted_country: '지역 제한된 국가에 있지 않습니다',
  },
  auth: {
    nickname: '닉네임',
    connect_to_win_4_poker: 'WIN 4 POKER에 연결',
    wallet_connect_need_to_connect_ur_wallet: '앱이 지갑 연결을 필요로 합니다',
    wallet_connect_sign_this_message:
      '지갑으로 돌아가 이 메시지에 서명하여 지갑 소유권을 증명하고 계속 진행하세요. 취소하면 연결이 끊어집니다.',
    sign_request_in_wallet: '지갑에서 요청 서명',
    sign_message_success: '서명 성공',
    cancel: '취소',
    sign: '서명',
    confirm_password: '비밀번호 확인',
    referral_code: '추천 코드',
    i_have_read_the_agreement: '저는 약관을 읽었음을 동의합니다',
    should_accept_agreement: '약관에 동의해야 합니다',
    alphabet_validation: '적어도 하나의 문자 포함',
    numeric_validation: '적어도 하나의 숫자 포함',
    length_validation: '8자 이상 20자 이하',
    placeholder: {
      enter_user_name: '사용자 이름 입력',
      enter_email: '이메일 입력',
      enter_password: '비밀번호 입력',
      confirm_password: '비밀번호 확인',
      enter_referral_code: '추천 코드 입력',
    },
    error_messages: {
      nickname: '닉네임을 입력해주세요',
      email_invalid: '유효하지 않은 이메일입니다',
      email_required: '이메일을 입력해주세요',
      password_required: '비밀번호를 입력해주세요',
      password_confirm_required: '비밀번호를 확인해주세요',
      password_confirm_not_matched: '입력한 두 비밀번호가 일치하지 않습니다!',
      incorrect_email_or_password: '이메일 또는 비밀번호가 올바르지 않습니다',
      error_occurred: '오류가 발생했습니다. 나중에 다시 시도해주세요',
    },

    // login-email page
    forget_password: '비밀번호를 잊으셨나요?',

    // forgot-password page
    forgot_password_title: '비밀번호를 잊으셨나요',
    please_enter_email_registered: '등록된 이메일을 입력해주세요',

    // email-verification page
    email_verification: '이메일 인증',
    email_has_been_sent_to: '이메일이 {{value}}으로 전송되었습니다',
    email_resend_countdown_message:
      '이메일을 받지 못하셨나요? <0>카운트다운</0> 후에 다시 요청할 수 있습니다',
    please_check_your_email: '이메일을 확인해주세요',
    waiting_to_verify_email: '이메일을 인증 중입니다',
    agree_terms_and_privacy:
      '이 절차를 계속하면 <0>약관</0>과 <1>개인정보 보호정책</1>에 동의하게 됩니다.',
    terms: '약관',
    privacy_policy: '개인정보 보호정책',

    // metamask-complete-registration page
    complete_metamask_registration: 'MetaMask 등록 완료',

    // reset-password page
    reset_password: '비밀번호 재설정',
    you_may_now_reset_password: '이제 계정의 비밀번호를 재설정할 수 있습니다.',

    register_an_account: '아직 계정이 없으신가요? <0>여기서 등록하세요</0>!',
    resend_code_message: '이메일을 받지 못하셨나요? <0>다시 보내기</0>를 클릭하세요',

    // 2FA setup page
    two_fa_via_email_title: '이메일을 통한 2단계 인증',
    otp_has_been_sent_to_email: '일회용 인증 코드가 등록된 이메일 주소로 전송되었습니다.',
    two_factor_authentication: '2단계 인증',
    scan_this_qr_code_msg:
      '2단계 인증을 설정하려면 Authy 또는 Google Authenticator와 같은 앱을 사용하여 이 QR 코드를 스캔하세요.',
    choose_scan_qr_code_msg:
      '인증 앱을 열고 오른쪽 하단의 + 아이콘을 클릭하세요. QR 코드 스캔을 선택하세요.',
    choose_enter_setup_key_msg:
      '인증 앱을 열고 오른쪽 하단의 + 아이콘을 클릭하세요. 설정 키 입력을 선택하세요.',
    secret_key: '비밀 키',
    enter_code_in_authenticator_app: '인증 앱에 표시된 코드를 입력하세요.',
    two_fa_is_set: {
      title: '2단계 인증 설정 완료',
      message: '2단계 인증이 설정되었습니다. 출금 기능을 사용할 수 있습니다.',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function:
      '일부 기능을 잠금 해제하려면 이메일 인증을 완료하세요',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '출금 한도를 100,000 USDT로 업그레이드하려면 신분 인증을 완료하세요',
    connect_wallet_to_spin: '지갑 연결',

    // enter code page
    link_email: '이메일 링크',
    unlink_email: '이메일 언링크',
    expires_in: '만료 시간 <0>분</0>.',
    resend_code: '<0>코드 재전송</0>',
    enter_code: '코드 입력',
    unlink_email_confirm_msg: '이메일을 언링크하시겠습니까?',
    link_success: '이메일이 링크되었습니다',
    unlink_success: '이메일이 언링크되었습니다',
  },
  slider: {
    about: '소개',
    support: '지원',
  },
  game_room: {
    confirm_leave_msg: '정말 게임을 떠나시겠습니까?',
    join_room_error_title: '방 참가 오류',
    join_room_error_msg: '방 참가에 실패했습니다. 다시 시도해 주세요',
    confirm_withdraw_extra_bet_msg: '추가 칩을 출금하시겠습니까?',
    total_won_prize: '총 상금: ${{val, number}}',
    your_balance: '잔액: ${{val, number}}',
    no_enough_balance: '최소 구매 칩보다 잔액이 부족합니다: ${{val, number}}',
    cash_out: '골드 수령 후 떠나기',
    continue_game: '게임 계속하기',
    remark_placeholder: '비고',
    leave_seat: '자리 떠나기',
    sit_in: '자리 돌아오기',
    buy_in: '구매',
    buy_in_min_amount: '최소',
    buy_in_max_amount: '최대',
    seconds: '초',
    close_drawer: '닫기',
    leave_game: '게임 떠나기',
    back_to_lobby: '로비로 돌아가기',
    leave_table: '테이블 떠나기',
    you_have_copied_room_code: '방 초대 코드가 복사되었습니다: {{value}}',
    invitation_message:
      '{{playerName}}이(가) 생성한 게임 방에 지금 바로 입장하세요! 방 초대 코드 {{roomNumber}}, 게임을 시작하세요!',
    link_copied: '링크가 성공적으로 복사되었습니다',
    please_wait_until_connected: '연결될 때까지 기다려주세요',
    rejoin_room: '방으로 돌아가기',
    theme_setting: '테마 설정',
    room_code_share: '방 초대 코드 복사',
    room_link_copy: '링크 공유',
    table_setting: '테이블 설정',
    emoji_menu: '이모지 메뉴',
    history_drawer: '방 역사',
    deposit: '입금',
    withdraw_extra_bet: '추가 칩 출금',
    add_extra_bet: '추가 칩 보충',
    unit_convert: '단위 변경',
    silent_mode_on: '무음 모드: 켜짐',
    silent_mode_off: '무음 모드: 꺼짐',
    raise_to: '상승',
    winner: '승자',
    player_status: {
      disconnected: '오프라인',
      sat_out: '자리 비움',
    },
    win_percentage: '승률',
    all_in: '올인',
    ping_popup_msg: '네트워크 신호가 불안정하여 재연결을 시도 중입니다',
    ping_popup_title: '네트워크 신호 불안정',
    ping_popup_content: '재연결을 시도 중입니다. 페이지를 새로 고침해 보세요',
    disconnected_modal_title: '네트워크 신호 불안정',
    afk_timer_text:
      '장시간 응답이 없어 자리를 떠나게 되었습니다. 제한 시간 내에 돌아오지 않으면 방에서 퇴장됩니다.',
    regular: '텍사스 포커',
    short: '쇼트 덱',
    omaha: '오마하',
    omaha_all_in: '올인 폴드 오마하',
    buyin_option: '구매 옵션',
    buy_in_amount: '구매 금액',
    reminder: '알림',
    not_enough_balance_to_buy_in: '구매할 충분한 금액이 없습니다.',
    sitting_out: '자리 비움',
    not_leaving_temporarily: '일시적으로 떠나지 않음',
    back_to_home: '홈으로 돌아가기',
    are_you_sure_leave_table: '가장 높은 베팅을 보유한 플레이어입니다. 정말 떠나시겠습니까?',
    leave_table_with_highest_bet_error:
      '가장 높은 베팅을 보유한 플레이어입니다. 테이블을 떠날 수 없습니다. 나중에 다시 시도하세요.',
    loading_room_data: '방 데이터를 불러오는 중...',
    sit_out_tournament_warning: {
      title: '토너먼트 자리 비움 경고',
      msg: '현재 토너먼트에 참가 중입니다. 자리를 비워도 블라인드를 계속 지불해야 합니다.',
    },
  },
  player_action: {
    bet: '베팅',
    call: '콜',
    check: '체크',
    raise: '레이즈',
    fold: '폴드',
    bb: '빅 블라인드',
    sb: '스몰 블라인드',
    ante: '안티',
    all_in: '올인',
    insurance_cancel: '보험 취소',
    insurance_buy: '보험 구매',
  },
  game_demo: {
    experience_progress: '체험 코드 완료 진행 상황',
    game_experience_zone: '게임 체험 구역',
    action_to_redemption: '30개의 유효 게임 완료 후 현금 코드로 교환',
    remaining_game_experience_code: '{{val, number}}개가 남았습니다',
    cash_code_exchange: '현금 코드 교환',
    successfully_finish_30_games: '성공적으로 완료했습니다',
    congrats: '축하합니다!',
    successful_exchange_cash_code: '{{amount}} 현금 코드로 성공적으로 교환되었습니다',
    how_to_redeem: '체험 코드를 현금 코드로 교환하는 방법',
    successful_condition_of_redemption: '조건: 30개의 유효 게임 완료',
    two_to_three_players: '2-3인 게임',
    explanation_of_valid_game:
      '10BB에 도달하고 게임 종료 시 자신이 카드를 공개해야 유효 게임으로 계산됩니다.',
    more_than_four_players: '4인 이상 게임',
  },
  userProfile: {
    profile_settings: '프로필 설정',
    initial_setting_title: 'Win4.Poker에 오신 것을 환영합니다',
    initial_setting_description: '아래의 초기 설정을 완료하고 게임을 즐기세요',
    display_name: '플레이어 이름',
    profile_picture: '플레이어 아바타',
    edit: '편집',
    balance: '잔액',
    coin: 'USD',
    demo_coin: '현금 체험 코드',
    diamond: '다이아몬드',
    game_record: '게임 기록',
    ranking_list: '랭킹 목록',
    game_review: '게임 복습',
    shortcut_setting: '단축 설정',
    user_name: '사용자 이름:',
    recommend_code: '추천 코드',
    upload_image_msg: '이미지를 여기에 끌어다 놓거나',
    upload_image_browser_msg: '브라우저',
    upload_image_file_size: '(파일 크기 최대: 68px*93px)',
    username_length_message: '사용자 이름 길이는 3-24자 사이여야 합니다',
    chinese_username_length_message:
      '중국어 문자를 포함한 사용자 이름 길이는 1-5자 사이여야 합니다',
    username_char_message:
      "사용자 이름에는 문자, 숫자, 중국어 문자 및 '_'/'-'/'.'만 포함할 수 있습니다",
    personal_information: '개인 정보',
    user_icon: '사용자 아바타:',
    save: '저장',
    my_profile: '내 프로필',
    my_balance: '내 잔액',
    deposit_withdraw: '입금/출금',
    my_record: '내 기록',
    flow_record: '거래 내역',
    total_earnings: '총 수익',
    country: '국가',
    disclaimer: '비고',
  },
  maintenance: {
    title: '사이트가 유지 보수 중입니다',
    content:
      '사용자 경험을 개선하기 위해 노력하고 있습니다. 곧 돌아오겠습니다. 기다려 주셔서 감사합니다.',
  },
  useSetting: {
    card_front: '카드 앞면',
    card_back: '카드 뒷면',
    table: '테이블',
    add_token_msg: '토큰을 더 추가하시겠습니까?',
  },
  lucky_draw: {
    award_history: '수상 내역',
    lucky_draw_rules: '규칙',
    remaining_lucky_draw_amount: '남은 스핀 횟수: {{value}}',
    remaining_lucky_draw_amount_loading_label: '남은 스핀 횟수: ',
    spin_wheel_10_times: '휠 10번 돌리기',
    spin_wheel: '휠 돌리기',
    participation_rate: '게임 참여율: {{count}}',
    coin_loss: '코인 손실',
    congrats: '축하합니다!',
    you_have_won: '축하합니다! ${{prize}}을(를) 획득하셨습니다.',
    collect_prize: '상금 수령',
    select_category: '추첨 카테고리 선택: ',
    special_combination: '특별 조합: ',
    no_history: '추첨 내역이 없습니다',
    no_data: '데이터가 없습니다',
    spin: '스핀',
    fortune_wheel: '포춘 휠',
    christmas_fortune_wheel: '크리스마스 포춘 휠',
    new_year_fortune_wheel: '새해 포춘 휠',
    cny_fortune_wheel: '중국 설날 행운의 바퀴',
    email_login: '이메일 로그인',
    thank_you: '감사합니다',
    miss_msg_1:
      '이벤트에 참여해주셔서 감사합니다. 남은 스핀이 없습니다. 게임에 참여하여 더 많은 상금을 획득하세요. 즐거운 시간 되시길 바랍니다. 행운을 빕니다!',
    play_now: '지금 플레이',
    win_msg:
      '당신은 이겼습니다 <br/> <large>{{prize}}</large> <br /> 그리고 귀하의 잔액에 저장되었습니다.',
    diamond: '{{value}} 다이아몬드',
    draw_again_msg:
      '당신은 <yellow>{{numOfDraws}}</yellow> 번의 추첨이 남아 있습니다. <clickable>다시 추첨하려면 클릭하세요.</clickable>',
    redeem_now: '지금 교환',

    deposit_more_than_10: '$10 이상 입금하기',
    get_1_free_spin: '1회 무료 스핀 받기',
    win_10_times: '10번 승리하기',
  },
  combination: {
    hi_card: '하이 카드',
    pair: '원 페어',
    one_pair: '원 페어',
    two_pairs: '투 페어',
    set: '쓰리 오브 어 카인드',
    three_of_a_kind: '쓰리 오브 어 카인드',
    straight: '스트레이트',
    flush: '플러시',
    fullHouse: '풀하우스',
    full_house: '풀하우스',
    quad: '포카인드',
    straight_flush: '스트레이트 플러시',
    royal_flush: '로열 플러시',
  },
  room_type: {
    public: '공개 방',
    private: '개인 방',
  },
  forgot_password: {
    reset_password: '비밀번호 재설정',
    password: '비밀번호',
    confirm_password: '비밀번호 확인',
    phone: '전화번호',
  },
  error: {
    please_confirm: '확인해주세요',
    password_inconsistent: '비밀번호가 일치하지 않습니다',
    file_size_limit_error: '업로드 파일 크기 제한: {{size}}',
    please_input: '{{field}}을(를) 입력해주세요',
  },
  translation: {
    success: '성공',
  },
  game_list: {
    table: '테이블',
    random_join_table: '무작위로 테이블 참가',
    random_join: '무작위 참가',
    join: '참가',
    no_room_available: '방이 없습니다. 나중에 다시 시도해주세요.',
    all_game_loaded: '모든 게임이 로드되었습니다',
    join_waiting_list: '대기 목록에 참가',
    join_table: '테이블 참가',
    join_observer: '관전',
    game_code: '테이블 코드',
    game_type: '게임 유형',
    game_limit: '인원 제한',
    game_players: '인원',
    game_unit_test: '유닛 테스트',
    game_basicBet: '기본 베팅',
    game_SB: '스몰 블라인드',
    game_smallBlind: '스몰 블라인드',
    regular: '텍사스 포커',
    all_in: '올인 폴드 텍사스 포커',
    short: '쇼트 덱',
    omaha: '오마하',
    omaha_all_in: '올인 폴드 오마하',
    buy_in: '구매',
    tables: '테이블',
    notice: '공지',
    time_difference_reminder:
      '시스템 시간과 인터넷 시간 간에 비정상적인 차이가 있어 플레이어 카운트다운 기능에 영향을 미칠 수 있습니다. 최상의 성능과 정확성을 위해 시스템 시간을 동기화해 주세요.',
    player_category: '플레이어 분류',
    blind_category: '블라인드 분류',
    table_category: '테이블 분류',
    chips: '칩',
    player: '플레이어',
    waiting: '대기',
    avg_pot: '평균 팟',
    flop_rate: '플롭 비율',
    hands_per_hour: '시간당 핸드 수',
    no_of_hands_played: '총 핸드 수',
    win: '승리',
    invested: '투자',
    pot: '팟',
    usd_balance_updated: 'USD 잔액이 ${{balance}}(으)로 업데이트되었습니다',
    new_room: '새 방',
    game: '현금 게임',
    tournament: '토너먼트',
  },
  game_review: {
    my_bets: '내 베팅',
    date_range: '날짜 범위',
    select_date_range: '날짜 범위 선택',
    show_all_dates: '모든 날짜 표시',
    show_selected_dates: '선택한 날짜 표시',
    no_game_record: '게임 기록이 없습니다',
    win_row_message: 'WIN!!',
    lose_row_message: '지출',
    ante: '안티',
    win: '승리',
    lose: '패배',
    main_pot: '메인 팟',
    side_pot: '사이드 팟{{number}}',
  },
  leader_board: {
    rank: '순위',
    name: '이름',
    win_game: '누적 승리 게임',
    score: '점수',
  },
  home: {
    dont_miss_promotion_msg: '프로모션을 놓치지 마세요',
    all_promotions: '모든 프로모션',
    my_game: '내 게임',
    all_games: '모든 게임',
    claim_first_time_reward_button: '알아보기',
    first_time_login: '처음 게임에 로그인하면,',
    first_time_reward_msg: '{{val}}개의 체험 코인을 받게 됩니다',
    open_table: '테이블 열기',
    open_new_room: '새 방 개설',
    enter_room_number: '방 코드 입력',
    start: '시작',
    enter_code: '코드 입력',
    confirm: '확인',
    game_selection: '게임 선택',
    start_game: '테이블 열기/방 입장',
    game_record: '게임 기록',
    join_private_room: '개인 방 초대',
    roomCode: '방 코드',
    please_enter_a_valid_room_code: '유효한 코드를 입력해주세요',
    notice: '공지',
    time_difference_reminder:
      '시스템 시간과 인터넷 시간 간에 비정상적인 차이가 있어 플레이어 카운트다운 기능에 영향을 미칠 수 있습니다. 시스템 시간을 동기화하고 페이지를 새로 고침하세요.',
    register_success: '회원가입 성공',
    referral_code: '추천 코드',
    referral_code_placeholder: '추천 코드 입력',
    display_name: '표시 이름',
    display_name_placeholder: '표시 이름 입력',
    user: '플레이어',
    bet_amount: '베팅 금액',
    date: '날짜',
    multiplier: '배수',
    payout: '상금',
    free_game: '무료 게임',
    play_without_money: '돈 없이 플레이',
    private_game: '개인 방',
    play_with_friends: '친구와 함께 플레이',
    regular_content: '일반 텍사스 포커는 무제한 베팅 방식으로 진행됩니다',
    all_in_content: '올인 또는 폴드 텍사스 포커는 무제한 베팅 방식으로 진행됩니다',
    short_content: '쇼트 덱 텍사스 포커는 무제한 베팅 방식으로 진행됩니다',
    omaha_content: '팟 제한 오마하는 무제한 베팅 방식으로 진행됩니다',
    omaha_all_in_content: '올인 또는 폴드 오마하는 무제한 베팅 방식으로 진행됩니다',
    player_statistics: '플레이어 현황',
    lucky_draw_reminder: {
      title: '알림',
      message: '{{value}}회의 행운 추첨이 남아있습니다',
      go_to_lucky_draw: '행운의 추첨으로 가기',
      spin_now: '지금 스핀',
    },
  },
  disclaimer: {
    title: '면책 조항',
    message: '다음 제한 지역에 거주하는 경우, win4.poker에서 게임을 할 수 없습니다',
    countryList:
      '미국, 터키, 아루바, 보네르, 퀴라소, 프랑스, 네덜란드, 스웨덴, 이스라엘, 리투아니아, 슬로바키아, 벨기에, 스위스, 사바, 생유스타스, 생마르탱, 중국, 영국.',
    checkbox_message:
      '저는 제가 거주하는 지역 당국에서 도박이 금지되지 않았으며, 만 18세 이상임을 확인합니다.',
    required_message: '면책 조항에 동의해야 합니다',
  },
  login: {
    user_account: '사용자 계정',
    password: '비밀번호',
    cash_web_login: '현금 웹 사용자 로그인',
    player_register: '플레이어 등록',
    gateway_user_name: 'Gateway 사용자 이름',
    cms_login: 'CMS 로그인',
    deposit: '입금',
    deposit_amount: '입금 금액',
    deposit_message: '입금 금액을 입력해야 합니다',
    notice: '공지',
    duplicate_login: '동일한 IP 로그인 감지됨',
    redirecting: '페이지가 곧 로드됩니다. 기다려주셔서 감사합니다.',
    loading: '자원을 로드 중입니다. 잠시만 기다려주세요...',
  },
  verification: {
    email_verification_code: '이메일 인증 코드',
    email_not_verify_error: '이메일이 인증되지 않았습니다',
    confirm: '확인',
    timer_count: '타이머 카운트',
    resend_verification_code: '인증 코드 재전송',
    send_verification_code: '인증 코드 보내기',
    input_field: '{{field}} 입력',
    code: '코드',
    successful_verify: '인증 성공',
    two_factor_authentication: '2단계 인증',
    verification: '인증',

    // KYC page
    verify: '인증',
    security: '보안',

    kyc_status: {
      failed_verify_again: '인증 실패, 다시 시도하세요',
      under_review: '검토 중',
      verify_now: '지금 인증',
    },

    complete_email_verification_to_unlock_some_function:
      '일부 기능을 잠금 해제하려면 이메일 인증을 완료하세요',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '출금 한도를 100,000 USDT로 업그레이드하려면 신분 인증을 완료하세요',
    requirement: '요구 사항',
    verify_now: '지금 인증',

    verification_code: '인증 코드',
    email_verification: {
      title: '이메일 인증',
      msg: '인증 코드를 받을 수 있는 이메일 주소를 입력하세요.',
      otp_has_been_sent_to: '인증 코드가 {{value}}으로 전송되었습니다',
    },

    id_card: '신분증',
    passport: '여권',

    identity_verification: {
      title: '신원 인증',
      msg: '유효한 신분증명서를 사용하여 신원을 인증하세요.',
      issuing_country: {title: '발행 국가 선택', placeholder: '국가 선택'},
      document_type: {
        title: '신분증명서 유형 선택',
        placeholder: '신분증명서 유형 선택',
      },
    },

    uploadDocument: {
      title: '문서 업로드',
      make_sure_that_your: '다음 사항을 확인하세요:',
      is_clear_and_easy_to_read: '명확하고 읽기 쉬워야 합니다',
      is_unedited: '편집되지 않아야 합니다',
      the_whole_doc_must_appear_in_photo: '전체 문서가 사진에 나타나야 합니다',
      no_reflective_glare: '반사광이 없어야 합니다',

      upload_image: '사진 업로드',
      upload_image_requirement:
        '파일 크기는 10MB 미만이어야 하며, jpeg 또는 png 형식을 지원합니다.',
      front_side_of_id: '신분증 앞면',
      back_side_of_id: '신분증 뒷면',
      personal_data_page_of_passport: '여권 개인 정보 페이지',
      document_uploaded: '문서가 업로드되었습니다',
      id_document_under_review_msg:
        '신분증명서가 검토 중이며, 인증이 완료되려면 1-2 영업일이 소요될 수 있습니다.',
    },

    disable_2fa: {
      title: '2단계 인증 비활성화',
      description: '계속하려면 인증 앱에서 제공한 인증 코드를 입력하여 신원을 확인하세요',
      success_message: '2단계 인증이 비활성화되었습니다',
    },

    error_messages: {
      document_upload_required: '문서를 업로드해주세요',
      selection_required: '옵션을 선택해주세요',
    },
  },
  table_area: {
    pot: '팟',
    waiting_for_other_players: '다른 플레이어의 입장을 기다리는 중...',
    waiting_for_game_start: '게임 시작을 기다리는 중',
    sixty_sec: '60초',
    please_select_emoji_target: '플레이어를 선택해주세요',
  },
  best_combination: {
    hi_card: '하이 카드 ({{value}})',
    one_pair: '원 페어 ({{value}})',
    two_pairs: '투 페어 ({{firstPair}}, {{secondPair}})',
    set: '쓰리 오브 어 카인드 ({{value}})',
    straight: '스트레이트 ({{fromValue}}부터 {{toValue}}까지)',
    flush: '플러시 ({{value}} 하이 카드)',
    fullHouse: '풀하우스 ({{three_cards}}와 {{two_cards}})',
    quad: '포카인드 ({{value}})',
    straight_flush: '스트레이트 플러시 ({{fromValue}}부터 {{toValue}}까지)',
    royal_flush: '로열 플러시',
  },
  action_buttons: {
    place_bet: '베팅하기',
    all_in: '올인',
    bet: '베팅',
    check: '체크',
    call: '콜',
    raise: '레이즈',
    fold: '폴드',
    pot: '팟',
    confirm: '확인',
    investment: '투자',
    insurance: '보험',
    choosing_cards: '카드 선택 중',
    outs_number: 'OUTS 수',
    insurance_winning_rate: '승률',
    odds: '배당률',
    premium: '보험료',
    payout: '상금',
    call_any: '자동 콜',
    wait_for_blinds: '블라인드 후 참가',
    join_directly: '다음 라운드 참가',
    check_or_fold: '체크 / 폴드',
    confirm_to_fold: '폴드하시겠습니까?',
    max: '최대',
    min: '최소',
    force_insurance: '강제 보험',
  },
  history_drawer: {
    title: '방 역사',
    small_blind: '스몰 블라인드(안티)',
    pre_flop: '플랍 전',
    flop: '플랍',
    turn: '턴',
    river: '리버',
    no_data: '방 데이터가 없습니다',
    hands: '핸드',
    winner: '승자',
    buy_in: '구매',
    pool: '팟',
    win_player: '승리한 플레이어',
    time: '시간',
    main_pot: '메인 팟',
    side_pot_one: '사이드 팟 1',
    side_pot_two: '사이드 팟 2',
    side_pot_three: '사이드 팟 3',
    win: '승리',
    loading: '로드 중',
    all_record_loaded: '모든 방 역사가 로드되었습니다',
    previous_page: '이전 페이지',
    close: '닫기',
    detail: '상세',
  },
  file_upload: {
    upload: '업로드',
  },
  user_menu: {
    two_factor: '2단계 인증',
    change_password: '비밀번호 변경',
    logout: '로그아웃',
    hello_user: '안녕하세요',
  },
  change_password_board: {
    change_password: '비밀번호 변경',
    old_password: '기존 비밀번호',
    new_password: '새 비밀번호',
    confirm_password: '비밀번호 확인',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: '검색...',
    filter: '필터',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: '읽기',
    write: '쓰기',
    none: '없음',
    banned: '금지됨',
  },
  phone_input: {
    invalid_country_code: '유효하지 않은 국가 코드',
    invalid_phone: '유효하지 않은 전화번호',
    phone_number: '전화번호',
    phone_code: '지역 코드',
  },
  room_setting_drawer: {
    create_new_room: '새 방 만들기',
    enter_room_code: '방 코드 입력',
    please_enter_a_valid_room_code: '유효한 코드를 입력해주세요',
    please_input_room_code: '방 코드를 입력해주세요',
    enter_room: '방 입장',
    room_setting: '방 설정',
    small_blind: '스몰 블라인드:',
    ante: '안티:',
    buy_in: '구매:',
    number_of_people: '인원:',
    action_time: '행동 시간:',
    game_duration: '게임 시간:',
    commission: '수수료:',
    insurance: '보험:',
    location_restriction: '위치 제한',
    diamond_needed: '필요한 다이아몬드:',
    diamond_owned: '보유 다이아몬드:',
    redeem: '다이아몬드 구매',
    open_room: '방 개설',
    maximum: '상한:',
    hours: '{{value}}시간',
    minute: '{{value}}분',
    second: '{{value}}초',
    affect_diamond_needed: '필요한 다이아몬드에 영향',
    remaining_room_time: '남은 방 시간:',
    diamond_require: '필요한 다이아몬드:',
    time_increase: '시간 증가:',
    recharge: '충전',
    isAllIn: '올인',
    ipchecking: 'IP 제한',
    diamond_not_enough: '다이아몬드 잔액이 부족합니다',
  },
  gameRecharge: {
    sticker_title: '스티커',
    check_for_more: '더 보기',
    diamond_title: '다이아몬드',
    diamond_product_tag: '{{value}} 다이아몬드',
    buy_diamond_confirm_msg: '구매 확인',
    buy_sticker_confirm_msg: '이 이모지를 구매하시겠습니까?',
    balance_not_enough_msg: '잔액이 부족합니다',
    sticker_product_tag: '{{value}} 다이아몬드 필요',
    confirm_to_buy_button: '확인',
    confirm_title: '구매 확인',
    confirm_message:
      'USD$ <0>{{usdAmount}}</0>를 사용하여 <1>{{diamondAmount}} 다이아몬드</1>를 구매하시겠습니까?',
    redeem: '충전',
    confirm: '확인',
    reminder: '알림',
    not_enough_money: '죄송합니다, 다이아몬드를 구매할 충분한 잔액이 없습니다.',
    not_enough_diamond: '다이아몬드 잔액이 부족합니다. 먼저 다이아몬드를 구매해주세요.',
    quanity: '수량:',
    price: '가격:',
    diamond: '다이아몬드',
    sticker: '이모지 스티커',
    purchase_success: '구매 성공',
    purchase: '구매',
    diamond_balance: '다이아몬드 잔액',
    free_sticker: '이 상품은 무료입니다',
    amount_required: '수량을 입력해야 합니다',
    valid_amount: '유효한 수량을 입력해주세요',
    not_enough_diamond_balance: '다이아몬드 잔액이 부족합니다',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: '전체',
      usd: 'USD',
      cash: '현금 체험 코드',
      diamond: '다이아몬드',
    },
    transactionType: {
      createRoom: '개인 방 개설',
      luckyDraw: '행운 추첨 참여',
      purchaseItem: '이모지 스티커 구매',
      purchaseDiamond: '{{value}} 다이아몬드 구매',
      joinGame: '{{value}} 게임 참여',
      winGame: '{{value}} 게임 승리',
      loseGame: '{{value}} 게임 패배',
      winGameWithoutGameType: '게임 승리',
      loseGameWithoutGameType: '게임 패배',
      joinGameWithoutGameType: '게임 참여',
      deposit: '충전',
      redeemDemo: '현금 코드 교환',
      insurance: '보험',
      gift: '선물',
      firstLogin: '첫 로그인',
      privateRoomRebate: '개인 방 리베이트',
    },
    transactionRecord: '거래 내역',
    no_transaction_record: '거래 기록이 없습니다',
    currentMonth: '이번 달',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: '이 이모지를 구매하시겠습니까?',
    sticker_product_tag: '{{value}} 다이아몬드 필요',
    confirm_to_buy_button: '구매 확인',
    emoji: '이모지',
    free: '무료',
    no_available_emoji: '사용 가능한 이모지가 없습니다',
  },
  playerInfo: {
    button: '딜러',
    smallBlind: '스몰 블라인드',
    bigBlind: '빅 블라인드',
    cutOff: '컷오프',
    underTheGun: '언더 더 건',
    bet: '베팅',
    check: '체크',
    call: '콜',
    raise: '레이즈',
    fold: '폴드',
    cancelInsurance: '보험\n취소',
    confirmInsurance: '보험\n확인',
    allIn: '올인',
    skip: '건너뛰기',
  },
  deposit_withdraw: {
    currency_usdt: '테더 (USDT)',
    deposit_method: '입금 방법',
    remark: '비고',
    ton_connect: 'TON 연결',
    manual_deposit: '수동 입금',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: '입금',
    withdraw: '출금',
    withdrawal: '출금',
    history: '입출금 기록',
    blockchain: '블록체인',
    currency: '통화',
    network: '네트워크',
    exchange_rate: '환율',
    deposit_address: '입금 주소',
    deposit_process_message_1:
      '시스템에서 입금을 확인하면 즉시 입금 처리를 진행하며, 약 2시간이 소요됩니다. 기다려주세요.',
    back: '뒤로가기',
    address: '주소',
    transaction_id: '거래 번호',
    amount: '출금 수량',
    time: '시간',
    coin_type: '통화 유형',
    available_amount: '출금 가능 금액',
    withdraw_amount: '출금 수량',
    withdraw_cost: '출금 수수료',
    receiving_amount: '예상 수령 금액',
    deposit_amount: '입금 수량',
    deposit_amount_placeholder: '입금 수량을 입력해주세요',
    no_data: '데이터 없음',
    address_placeholder: '주소를 입력해주세요',
    amount_placeholder: '수량을 입력해주세요',
    withdrawal_amount: '출금 수량',
    withdrawal_fee: '출금 수수료',
    max: '최대',
    available_cash_out_balance: '출금 가능 잔액',
    cash_out_info:
      '상금 풀 참여 후, 포커 게임에서 획득한 USDT만 출금할 수 있으며, 게임 무승부 시 출금할 수 있습니다.',
    wallet_balance: '지갑 잔액',
    deposit_pending_title: '입금 대기 중',
    deposit_pending_description: '입금이 현재 승인 대기 중입니다',
    deposit_success_title: '입금 성공',
    deposit_success_description: '자금이 계정에 입금되었습니다',
    create_withdraw_success_title: '출금 요청 성공',
    create_withdraw_success_description: '출금 요청이 처리 중입니다',
    withdrawal_success_title: '출금 성공',
    withdrawal_success_description: '출금 요청이 완료되었습니다',
    amount_required: '금액이 필요합니다',
    amount_exceeds_available: '금액이 사용 가능한 잔액을 초과했습니다',
    amount_below_minimum: '금액이 최소 한도보다 낮습니다',
    amount_below_fee: '금액이 수수료보다 낮습니다',
    invalid_number: '유효하지 않은 숫자입니다',
    network_required: '네트워크를 선택해야 합니다',
    address_required: '주소를 입력해야 합니다',
    blockchain_required: '블록체인을 선택해야 합니다',
    email_required: '이메일을 입력해야 합니다',
    valid_amount: '유효한 금액을 입력해주세요',
    notice: '공지',
    cancel: '취소',
    cancel_transaction: '거래를 취소했습니다',

    from: '출처',
    receive_amount: '수령 금액',

    // 2FA
    two_fa_required_msg: '보안을 위해 출금 전에 2단계 인증을 설정해야 합니다.',
    setup_2fa: '2단계 인증 설정',
    lost_my_2fa_access: '2단계 인증 접근을 잃어버렸습니다',

    wallets_usdt_token: '지갑의 USDT 토큰',
    memo_reminder_1:
      '{{memo}}를 메모 섹션에 입력했는지 확인해주세요. 메모나 주소가 잘못 입력되면 시스템이 귀하의 계정에 자금을 입금할 수 없습니다.',
    memo_reminder_2: 'TonConnect를 사용하는 경우, 시스템이 자동으로 입력합니다.',

    wait_for_next_lucky_draw:
      '다음 행운의 추첨 이벤트를 기다려 주세요. 플레이할 자금을 받을 기회가 있습니다.',
  },
  history_status: {
    completed: '완료',
    pending: '처리 중',
  },
  transaction_history: {
    tab_titles: {
      all_flow: '전체 거래',
      deposits: '입금',
      withdrawals: '출금',
      bets: '베팅',
      purchase: '다이아몬드 구매',
      diamond: '다이아몬드',
    },
    transaction_type: '거래 유형',
    transaction_types: {
      deposits: '입금',
      withdrawals: '출금',
      bets: '베팅',
      purchase: '다이아몬드 구매',
      diamond: '다이아몬드',
      purchase_item: '다이아몬드 거래',
      referral_commission: '추천 수수료',
      payout: '상금',
      private_room: '개인 방 개설',
      private_room_rebate: '개인 방 리베이트',
      reward: '보상',
      lucky_draw: '행운 추첨',
      tournament_prize: '토너먼트 상금',
      tournament_ticket_fee: '토너먼트 티켓 요금',
    },
    game_type: '게임 유형',
    type: '유형',
    bet: '베팅',
    payout: '상금',
    amount: '금액',
    quantity: '수량',
    balance: '잔액',
    diamond: '다이아몬드',
    sticker: '스티커',
  },
  referral: {
    referral: '추천',
    invite_friends_description: 'Win4Poker에 친구를 초대하고 보상을 받으세요',
    whatsapp_referral_message:
      '이제 승리할 준비가 되셨나요? 🃏 Win4Poker에서 저와 함께 멋진 대전을 즐기세요! 제 초대 링크는 다음과 같습니다: ',
    number_of_referrals: '추천 인원수',
    referral_rewards: '추천 보상',
    my_commission: '내 수수료',
    referral_code: '추천 코드',
    referral_link: '추천 링크',
    enter_code: '코드 입력',
    terms_and_conditions: 'Win4Poker 약관 및 조건',
    invite_friends: '친구 초대',
    pop_up_title: '공지',
    back_home: '홈으로 돌아가기',
    scan_qr_code: 'QR 코드 스캔',
    code: '코드',
    copy_link: '링크 복사',
    save_image: '이미지 저장',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: '더 보기',
    referral_history: '추천 기록',
    register_time: '등록 시간',
    player: '플레이어',
    reward_time: '보상 시간',
    reward_amount: '보상 금액',
    referral_list: '추천 목록',
    enter: '입력',
    skip: '건너뛰기',
    please_input_referral_code: '추천 코드를 입력해주세요',
    enter_referral_code: '추천 코드 입력',
    enter_referral_code_success: '추천 코드 입력 성공',
    cannot_use_own_referral_code: '자신의 추천 코드를 사용할 수 없습니다',
    total: '총합',
    referral_code_invalid: '추천 코드가 유효하지 않습니다',
    commission: '수수료',
    reward_type: '보상 유형',
    amount: '금액',
    commission_reward: '수수료 보상',
    commission_update_success: '수수료 업데이트 성공',
    commission_setting: '수수료 설정',
    save: '저장',

    // title
    promotion_1: '추천 1: 입금 보너스',
    promotion_2: '추천 2: 추천 코드 보상',
    general_terms: '일반 약관 및 조건',

    // sub-title
    eligibility: '자격',
    offer: '제공',
    conditions: '조건',
    program_duration: '프로그램 기간',
    account_verification: '계정 인증',
    limitations: '제한',
    modification_of_terms: '약관 수정',
    compliance: '준수',
    support: '지원',

    error_messages: {
      referral_code_invalid: '추천 코드는 4~8자여야 하며, "I"와 "O"를 제외한 영숫자만 포함할 수 있습니다',
      referral_code_required: '추천 코드는 필수입니다',
    },

    // points
    eligibility_1: '사용자는 Win4Poker 계정에 1 USDT 이상을 입금해야 합니다.',
    offer_1: '자격을 갖춘 사용자는 1 USDT의 무료 선물을 받아 계정에 직접 입금됩니다.',
    conditions_1: '이 혜택에는 제한이 없습니다.',
    conditions_2: '입금은 Win4Poker에서 지정한 추천 기간 내에 이루어져야 합니다.',
    conditions_3: '사용자는 이 추천 자격을 충족하려면 인증된 계정을 보유해야 합니다.',

    eligibility_2: '사용자는 고유한 추천 코드를 사용하여 친구를 추천해야 합니다.',
    offer_2:
      '추천된 친구가 첫 게임을 완료하면, 추천인은 상금 풀 총액의 3.5%를 보상으로 받게 됩니다.',
    conditions_4: '추천된 친구는 추천인의 코드를 사용하여 등록해야 합니다.',
    conditions_5: '보상은 추천된 친구가 게임을 완료한 후 2시간 이내에 지급됩니다.',
    conditions_6: '사용자는 계정 대시보드를 통해 추천 및 보상을 추적할 수 있습니다.',
    program_duration_1:
      '이 추천 활동은 웹사이트 및 공식 채널에 공지된 지정된 기간 동안 진행됩니다.',
    account_verification_1:
      '참여자는 모든 보상 자격을 충족하려면 완전히 인증된 계정을 보유해야 합니다.',
    limitations_1:
      '추천 시스템을 남용하는 것으로 발견된 사용자(예: 자기 추천)의 경우, 계정이 일시 정지되거나 금지될 수 있습니다.',
    modification_of_terms_1:
      'Win4Poker는 언제든지 사전 통지 없이 이러한 추천 활동을 수정하거나 종료할 권리를 보유합니다.',
    compliance_1: '참여자는 해당 관할 구역 내의 온라인 게임 및 추천 관련 법규를 준수해야 합니다.',
    support_1: '추천 프로그램에 대한 질문이나 도움이 필요하면 고객 지원팀에 문의하세요.',

    // disclaimer
    disclaimer: '면책 조항',
    disclaimer_1: '모든 보상은 재고에 따라 제한되며 계정 상태 및 활동에 따라 변경될 수 있습니다.',
    disclaimer_2:
      'Win4Poker는 추천을 성공적으로 추적하는 데 방해가 되는 기술 문제에 대해 책임을 지지 않습니다.',

    fixed_commission: '고정 수수료',
    custom_commission: '사용자 정의 수수료',
    invalid_commission_percentage: '유효하지 않은 수수료 백분율',
    commission_placeholder: '수수료 백분율 입력',
    my_share: '내 공유',

    commission_calculation: {
      title: '수수료 계산',
      first_layer: '1차 레벨 %',
      second_layer: '2차 레벨 %',
      third_layer: '3차 레벨 %',
      refers: '추천',
      referrer: '추천인',
      content:
        '상금의 5%가 수수료로 공제됩니다. 게이트웨이는 수수료의 30%를 <0>최대</0>로 받습니다. 게이트웨이는 수수료의 나머지 70%를 최상위 추천인에게 배분하며, 이 추천인은 수수료 70% 중 Z%를 다음 레벨의 추천인에게 할당하기로 결정할 수 있습니다. 다음 레벨 추천인은 수수료의 Z% 중 Y%를 그 아래 레벨에 배분하기로 결정할 수 있으며, 이 과정은 수수료가 승자의 추천인에게 도달할 때까지 계속됩니다.',
      example: {
        title: '예시:',
        winner_wins: '승자 상금: ${{value}}',
        total_commission: '총 수수료: ${{value}}',
        gateway_total_commission_max: '게이트웨이 총 수수료 (최대): ${{value}}',
        referral_total_commission_min: '추천 총 수수료 (최소): ${{value}}',

        referral_commissions: '추천 수수료 (70 ≥ Z ≥ Y ≥ X ...):',
        referrer_1_commission: '추천인 1: ${{totalCommission}} × (Z% - Y%)',
        referrer_2_commission: '추천인 2: ${{totalCommission}} × (Y% - X%)',
        referrer_3_commission: '추천인 3: ${{totalCommission}} × X%',
      },
    },
  },
  ranking: {
    ranking: '랭킹',
    today: '오늘',
    this_week: '이번 주',
    this_month: '이번 달',
  },
  tournament: {
    you_have_won: '당신이 이겼습니다',
    time_elapsed: '경과 시간',
    prize_pool: '상금 풀',
    entries: '참가자',
    of: '의',
    congratulations: '축하합니다',
    thanks_for_your_joining: '참여해 주셔서 감사합니다',
    watch: '관전',
    see_result: '결과 보기',
    view_tournament: '토너먼트 보기',
    deregister: '등록 취소',
    start_in: '<0>countdown</0> 후 시작',
    full: '만석',
    register_end_in: '등록 마감 <0>countdown</0> 전',
    my_ranking: '내 순위',
    players: '플레이어',
    register: '등록',
    pay_for_registration: '등록을 위해 {{ticketFee}} 결제',
    register_confirmation_message:
      '토너먼트 등록을 위해 {{ticketFee}} 티켓 요금이 부과됩니다. {{tournamentName}}에 등록하시겠습니까?',
    late_register: '후발 등록',
    level: '레벨',
    blinds: '블라인드 (SB/BB)',
    ante: '앤티',
    duration: '기간',
    game_rule: '게임 규칙',
    game_mode: '게임 모드',
    speed: '속도',
    general_information: '일반 정보',
    ticket_fee: '참가비',
    starting_stack: '시작 스택',
    blinds_start: '블라인드 시작',
    ante_starts: '앤티 시작',
    raised_every: '상승 간격',
    minutes: '분',
    prize: '상금',
    structure: '구조',
    gameModeTitle: {
      classic: '클래식',
      turbo: '터보',
      hyper: '하이퍼',
    },
    gameModeDescription: {
      classic:
        '클래식 멀티 테이블 토너먼트로, 참가자들이 총 상금 풀의 일부를 획득하기 위해 경쟁합니다.',
    },
    speedTitle: {
      regular: '일반',
      turbo: '터보',
      hyper: '하이퍼',
    },
    speedDescription: '블라인드가 {{value}}분마다 상승합니다',
    tournament: '토너먼트',
    today: '오늘',
    yesterday: '어제',
    tomorrow: '내일',
    upcoming: '예정된 토너먼트',
    results: '결과',
    on_going: '진행 중',
    title: '토너먼트 상세 정보',
    tables: '테이블',
    minutes_short: '분',
    current_blinds: '현재 블라인드',
    next_blind_at: '다음 블라인드 시간',
    start_game_in: '게임 시작까지',
    no_tournaments_available: '이용 가능한 토너먼트가 없습니다',
    you_have_not_participated_in_any_tournament_yet: '아직 어떤 토너먼트에도 참가하지 않았습니다',
    tournament_started: '토너먼트가 시작되었습니다',
    tournament_ended_msg: '토너먼트가 종료되었습니다',
    tournament_canceled_msg: '토너먼트가 취소되었습니다',
    view_table: '테이블 보기',
    view_player_table: '플레이어 테이블 보기',
    table_rebalancing: '테이블 리밸런싱',
    upcoming: '예정된 토너먼트',
    in_progress: '진행 중',
    finished: '종료된 토너먼트',
    waiting_enough_players_to_start: '충분한 플레이어가 모이기를 기다리고 있습니다',
    cancelled: '취소된 토너먼트',
    too_many_rooms_description:
      '{{tournamentName}}이(가) 곧 시작됩니다만, 최대 테이블 수에 도달했습니다. {{tournamentName}}에 참가하려면 다음 테이블 중 하나 이상을 나가주세요.',
    leave: '나가기',
    sit_in: '{{name}}에 참가하기',
    ignore: '무시하기',

    re_entry_modal: {
      title: '토너먼트에 재입장하시겠습니까?',
      description:
        '{{tournamentName}}에 아직 참가할 수 있습니다. ${{ticketFee}} 참가비를 지불하고 토너먼트에 재참가하시겠습니까?',
      re_enter: '재입장',
      view_tournament: '토너먼트 보기',
    },
    waiting_for_players: {
      title: '플레이어 대기 중',
      message: '{{count}}명의 플레이어를 더 기다리고 있습니다',
      message_plural: '{{count}}명의 플레이어를 더 기다리고 있습니다',
    },
    thanks_for_joining: {
      title: '참가해 주셔서 감사합니다!',
      description: '{{tournamentName}}에 참가해 주셔서 감사합니다. 토너먼트가 아직 진행 중입니다. 나중에 결과를 확인하실 수 있습니다.',
      view_results: '토너먼트 결과 보기',
    },
    cancel: {
      title: '토너먼트 취소됨',
      description: '토너먼트 "{{tournamentName}}"이(가) 취소되었습니다.',
      refund_message: '참가비 ${{amount}}이(가) 환불될 예정입니다.',
      confirm: '확인',
    },
    waiting_timer: {
      title: '플레이어 대기 중',
      cancel_in: '취소까지',
    },
    waiting_for_players_timer: '플레이어 대기 중',
    cancel_in: '취소까지',
  },
  errorCodes: {
    default: {
      title: '시스템 오류',
      message: '문제가 발생했습니다. 나중에 다시 시도해 주세요',
    },

    WS_0000: '시스템 오류',
    WS_0001: '4개 이상의 방에 입장할 수 없습니다',
    WS_0002: '최대 베팅 시점에 떠날 수 없습니다',
    WS_0003: '인증 오류, 페이지를 새로 고친 후 다시 시도하세요',
    WS_0004: '방 내에 인근 사람이 감지되어 현재 방에 입장할 수 없습니다',
    WS_0005: '최고 베팅을 보유한 플레이어를 떠날 수 없습니다. 먼저 폴드하세요',
    WS_0006: '구매 오류',
    WS_0007: '게임룸을 찾을 수 없습니다',

    HP_0001: '4개 이상의 방에 입장할 수 없습니다',
    HP_0002: '현재 서버에 연결할 수 없습니다. 나중에 다시 시도하세요.',
    HP_0003: '구매 금액 부족',
    HP_0004: '유효하지 않은 인증 코드',
    INVALID_EMAIL_PASS_CODE: '유효하지 않은 인증 코드',
    INVALID_OTP: '유효하지 않은 인증 코드',
    INVALID_REFERRAL_CODE: '유효하지 않은 추천 코드',
    REFERRAL_CODE_ALREADY_USED: '이미 사용된 추천 코드',
    INSUFFICIENT_COINS: '지갑 잔액 부족',
    JOIN_TOURNAMENT_ERROR: '토너먼트 참가 오류',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: '위치 액세스가 거부되었습니다.',
      POSITION_UNAVAILABLE: '위치 정보를 사용할 수 없습니다. 나중에 다시 시도하세요.',
      TIMEOUT: '위치 요청 시간이 초과되었습니다. 다시 시도하세요.',
      UNKNOWN: '위치를 요청하는 동안 알 수 없는 오류가 발생했습니다.',
    },
    TOURNAMENT_IS_FINISHED: '토너먼트가 종료되었습니다',
    GPS_RESTRICTION:
      '위치를 감지할 수 없거나 근처의 플레이어가 같은 방에 참여했습니다. 나중에 다시 시도하세요',
  },
};
